import {
  NotificationActionContract,
  NotificationUrlActionContract,
} from '../contracts/notification-action.contract';
import { NotificationContract } from '../contracts/notification.contract';

export function getClickActions(
  action: NotificationContract | string | NotificationActionContract,
): Exclude<NotificationActionContract, 'title'> | undefined {
  if (typeof action === 'object' && 'body' in action) {
    if ('clickAction' in action && typeof action.clickAction === 'string') {
      return {
        url: action.clickAction,
      } as Exclude<NotificationUrlActionContract, 'title'>;
    }
    return action.actions[0];
  } else if (typeof action === 'string') {
    return {
      url: action,
    } as Exclude<NotificationUrlActionContract, 'title'>;
  }
  return action;
}
